<template>
<!-- 订单-返程费 -->
  <div class="container">
    <div class="handle-box-search">
      <el-button @click="add_isShow = !add_isShow" type="primary"
        >添加</el-button
      >
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
    </div>
    <el-table
      :data="tableData"
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column label="名称" prop="name" min-width="100">
      </el-table-column>
      <el-table-column label="创建时间" prop="time.YmdHis" min-width="100">
      </el-table-column>
      <el-table-column label="修改时间" prop="updated_at" min-width="100">
      </el-table-column>
      <el-table-column label="生效开始时间" prop="time_start" min-width="100">
      </el-table-column>
      <el-table-column label="生效结束时间" prop="time_end" min-width="100">
      </el-table-column>
      <el-table-column label="公里数" min-width="100">
        <template slot-scope="scope">
          {{ getDistance(scope.row.distance_period) }}
        </template>
      </el-table-column>
      <el-table-column label="费用" min-width="100">
        <template slot-scope="scope">
          {{ getFee(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="返程费抽成" prop="deduct" min-width="100">
      </el-table-column>
      <el-table-column label="关联订单模式" prop="order_mode" min-width="300">
      </el-table-column>
      <el-table-column label="开启状态" prop="status.alias" min-width="100">
      </el-table-column>
      <el-table-column label="操作" width="270" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            trigger="click"
            @click="edit_returnFee(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            type="primary"
            trigger="click"
            @click="delReturnFee(scope.row.return_trip_conf_code)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- element ui 原生分页组件 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="search_data.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="result_data.count"
      >
      </el-pagination>
    </div>
    <!-- 添加组件 -->
    <addReturnfee
      :isShow="add_isShow"
      @onSubmit="returnFeeLists"
    ></addReturnfee>
    <!-- 编辑组件 -->
    <editReturnfeeSubmit
      :isShow="edit_isShow"
      :data="orderMode_code"
      :checkedModes_edit_child="checkedModes"
      @onSubmit="returnFeeLists"
    ></editReturnfeeSubmit>
  </div>
</template>
<script>
var _this;
import bus from '@/components/common/bus.js';
import addReturnfee from "./addReturnfee.vue";
import editReturnfeeSubmit from "./editReturnfeeSubmit.vue";
export default {
  components: {
    addReturnfee,
    editReturnfeeSubmit,
  },
  data() {
    return {
      checkedModes: "",
      checkedModes_edit_child: "",
      edit_isShow: false,
      add_isShow: false,
      orderMode_code: "",
      //获取用户列表的数据
      search_data: {
        page: 1,
        limit: 10,
     
      },
      // 存放表格数据
      tableData: [],
      result_data: [],
      search_rules: {
        page: {
          placeholder: "页码",
          rules: {
            required: true,
            message: "页码需要大于0",
            regulation: "gt",
            rulesData: 0,
          },
        },
        limit: {
          placeholder: "每页个数",
          rules: {
            required: true,
            message: "每页个数需在1-51之内",
            regulation: "between",
            rulesData: [1, 51],
          },
        },
      },
    };
  },
  created() {
    _this = this;
    _this.searchReturnfeeLists();
  },

  computed: {
    // 列表公里数
    getDistance() {
      return (val) => {
        let valArr = JSON.parse(val);
        if (valArr[1] != "") {
          // 存在第二位
          return valArr[0] + "公里-" + valArr[1] + "公里";
        } else {
          // 数据只有一位
          return valArr[0] + "公里及以上";
        }
      };
    },
    // 列表费用
    getFee() {
      return (val) => {
        let valArr1 = val.fee_amount;
        let valArr2 = val.fee_rate;

        return valArr1 + "+" + "订单费用*" + valArr2 + "%";
      };
    },
  },

  methods: {
    // 编辑
    edit_returnFee(val) {
      _this.edit_isShow = !_this.edit_isShow;
      _this.orderMode_code = val.return_trip_conf_code; //子组件data值
      _this.checkedModes = val.order_mode; //子组件多选框绑定值
    },
    // 删除
    delReturnFee(code) {
      _this
        .$confirm("此操作将删除该条数据, 是否继续?", "提示", {
          confirmButtonText: "确定",

          cancelButtonText: "取消",

          type: "warning",
        })
        .then(() => {
          _this
            .$post("/returnfee/delDynamicMarkupSubmit", {
              return_trip_conf_code: code,
            })
            .then((res) => {
              _this.$message.success(res.msg);
              _this.returnFeeLists();
            })
            .catch((err) => {});
        })
        .catch(() => {
          _this.$message({
            message: "已取消删除",
            duration: 1500,
          });
        });
    },
    //下拉条（每页显示多少数据）变化
    handleSizeChange(val) {
      // console.log(val, 'val');
      _this.search_data.limit = val;

      //初始化列表
      _this.returnFeeLists();
    },
    //页码变化
    handleCurrentChange(val) {
      _this.search_data.page = val;
      //初始化列表
      _this.returnFeeLists();
    },
    // 搜索
    searchReturnfeeLists() {
      _this.search_data.page = 1;
      _this.returnFeeLists();
    },
    // 初始化列表
    returnFeeLists() {
      _this
        .$post(
          "/returnfee/returnFeeLists",
          _this.search_data,
          _this.search_rules
        )
        .then((res) => {
          // 将请求的数据存放到表格数据数组中
          _this.tableData = res.data.result;

          _this.result_data = res.data;
        })
        .catch((err) => {});
    },
    // 刷新按钮
    refresh() {
      this.$router.go(0);
    },
  },
};
</script>
<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  max-width: 150px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.el-table__row {
  height: 100px;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>